export default "__VITE_ASSET__BpF0wtAV__"